import { ROLES } from '@/constants/roles';

export const uiPersonal = {
  path: '/staff',
  name: 'ui-personal',
  component: () => import('./views/index.vue'),
  meta: {
    layout: 'ui-design',
    icon: '$ui-plus',
    title: 'Персонал',
    accessList: [ROLES.organization, ROLES.event_manager],
  },
};

export default [
  uiPersonal,
  {
    path: '/staff/experts',
    name: 'ui-personal-experts',
    component: () => import('./views/Experts.vue'),
    meta: {
      layout: 'ui-design',
      title: 'Эксперты',
      back: true,
      accessList: [ROLES.organization, ROLES.event_manager],
    },
  },
  {
    path: '/staff/event-managers',
    name: 'ui-personal-managers',
    component: () => import('./views/EventManagers.vue'),
    meta: {
      layout: 'ui-design',
      title: 'Event-менеджеры',
      back: true,
      accessList: [ROLES.organization, ROLES.event_manager],
    },
  },
];
